/**
 * PromotionRegisterContainer
 * --
 */
import React from 'react';
import PromotionRegisterPresenter from './PromotionRegisterPresenter';

const PromotionRegisterContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <PromotionRegisterPresenter />
    </>
  );
};

export default PromotionRegisterContainer;
